import {memo} from 'react';
import {useSelector} from 'react-redux';
import {useGuestlistDataContext} from '~/ViewInvitation/components/Guestlist/hooks/useGuestlistDataContext';
import {selectOptions} from '~/ViewInvitation/selectors/eviteEvent';
import {Typography} from '~library/atoms/Typography';

import * as styles from './GuestsCount.module.scss';

export const GuestsCount = memo(() => {
  const {
    state: {guestlist, rsvpResponse, query},
  } = useGuestlistDataContext();
  const familyHeadcountEnabled = useSelector(selectOptions)?.event_option_allow_kids;
  const onYesOrMaybe = rsvpResponse === 'yes' || rsvpResponse === 'maybe';
  const totalAdults = guestlist?.reduce((acc, guest) => acc + guest.numberOfAdults, 0);
  const totalKids = guestlist?.reduce((acc, guest) => acc + guest.numberOfKids, 0);

  if (!familyHeadcountEnabled || !onYesOrMaybe || !!query) return null;

  return (
    <div className={styles.row}>
      <div className={styles.totals}>
        <Typography variant="list2" className={styles.uppercase}>
          Total Adults
        </Typography>
        <Typography variant="list2" className={styles.pill} as="span">
          {totalAdults}
        </Typography>
        <Typography variant="list2" className={styles.uppercase}>
          Total Kids
        </Typography>
        <Typography variant="list2" className={styles.pill} as="span">
          {totalKids}
        </Typography>
      </div>
    </div>
  );
});

GuestsCount.displayName = 'GuestsCount';
